export default "__VITE_ASSET__8b586dcb__"